import React, {Component} from 'react'
import Propic from './img/thabs.PNG';

class Sidebar extends Component {
    constructor(props){
        super(props);
        this.state= {
          ha: 'active',
          ca: '',
          pa: '',
          aa: '',
          color: ' black',
        }
      }

    setactive = (presser) => {
        if(presser === 'home'){
            this.setState({
            ha: 'active',
            ca: '',
            pa: '',
            aa: '',
            })
        }else if(presser === 'cv'){
            this.setState({
            ha: '',
            ca: 'active',
            pa: '',
            aa: '',
            })
        }else if(presser === 'portfolio'){
            this.setState({
            ha: '',
            ca: '',
            pa: 'active',
            aa: '',
            })
        }else if(presser === 'about'){
            this.setState({
            ha: '',
            ca: '',
            pa: '',
            aa: 'active',
            })
        }
        this.props.alterpage(presser)
    }

    render(){
        const {
        ha,
        ca,
        pa,
        aa, 
        color,
        } = this.state

        return(
        <div className="inner-bar">
           <img src={Propic} alt="Thabiso Simon Zwane"/>
           <p className="name"><b>Thabiso Zwane</b></p>
           <p className="name">zwanets@hotmail.com</p>
            <ul className="menu-list">
            <li className={ha + color} onClick={this.setactive.bind(this, 'home')}><p className="list-item">Home</p></li>
            <li className={ca + color} onClick={this.setactive.bind(this, 'cv')}><p className="list-item">CV</p></li>
            <li className={pa + color} onClick={this.setactive.bind(this, 'portfolio')}><p className="list-item">Portfolio</p></li>
            <li className={aa + color} onClick={this.setactive.bind(this, 'about')}><p className="list-item">About</p></li>
            </ul>
            </div>
        )
    }

}

export default Sidebar;